import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { AuthPageWrapper } from '@app/components';

import { CreateAccountForm } from './CreateAccountForm';

import './CreateAccountPage.scss';

const cnBem = createBemBlockBuilder(['createAccountPage']);

export const CreateAccountPage = () => {
  const { $t } = useIntl();

  return (
    <>
      <Helmet>
        <title>
          {$t({
            id: 'createAccount.title',
            defaultMessage: 'Create account - EBSCO Locate',
          })}
        </title>
      </Helmet>
      <AuthPageWrapper className={cnBem()}>
        <CreateAccountForm />
      </AuthPageWrapper>
    </>
  );
};
